import api from '@/api';

const actions = {
  fetchSearchAssociate({ commit }, query) {
    return api.fetchSearchAssociate({ queryText: query, lang: 'zh-cn' })
    .then(({ data }) => {
      commit('SET_SEARCH_ASSOCIATE', { result: data.data.suggestionList });
    });
  },

  clearAssociate({ commit }) {
    commit('CLEAR_ASSOCIATE');
  },
};

export default actions;



// WEBPACK FOOTER //
// ./src/store/actions.js